import { observer } from 'mobx-react-lite';
import { useMainContext } from '../../../hooks/useMainContext';
import { useState } from 'react';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { Collapse, message } from 'antd';
import UnitCollapseHeader from './UnitCollapseHeader';
import ClosetData from './ClosetData';
import DeleteModel from '../../Globle/DeleteModel';

const UnitCloset = observer(() => {
    const { closetManager, uiManager, viewManager, drawingManager } =
        useMainContext();
    const [activeKeys, setActiveKeys] = useState(null);
    const [isModelOpen, setIsModelOpen] = useState(false);
    const [selectedUnit, setSelectedUnit] = useState(null);

    const handleFitToScreen = async (unitId) => {
        await closetManager.showUnits(unitId);
    };

    const handleEdit = (unit) => {
        if (viewManager.matrixCalculation) return;
        const selectedUnit = closetManager.units.find(
            (u) => u._id === unit._id,
        );
        closetManager.setSelectedUnit(selectedUnit);
        viewManager.setUnitForm(true);
    };
    const handleDelete = (unit) => {
        if (drawingManager.isDrawingModeOn) {
            message.error("Can't do this operation while drawing mode is on.");
            return;
        }
        setIsModelOpen(true);
        setSelectedUnit(unit);
    };
    const handleCancel = () => {
        setIsModelOpen(false);
        setSelectedUnit(null);
    };
    const handleConfirmDelete = () => {
        if (viewManager.matrixCalculation) return;
        closetManager.removeUnitById(selectedUnit._id);
        handleCancel();
    };
    const expandIcon = ({ isActive }) => (
        <div className="cursor-pointer">
            {isActive ? (
                <IoIosArrowUp size={20} className="text-theme-black" />
            ) : (
                <IoIosArrowDown size={20} className="text-theme-black" />
            )}
        </div>
    );

    const data = uiManager.handleStructureData();

    const items = data.map((unit) => ({
        label: (
            <UnitCollapseHeader
                unit={unit}
                handleFitToScreen={() => handleFitToScreen(unit._id)}
                handleEdit={() => handleEdit(unit)}
                handleDelete={() => handleDelete(unit)}
            />
        ),
        key: unit._id,
        children: <ClosetData closets={unit.unitClosets} />,
        className: 'custom-unit-item',
    }));
    return (
        <>
            <div className="mt-[16px] max-h-[calc(100vh-310px)] overflow-y-auto pr-[8px]">
                {closetManager.units.length === 0 ? (
                    <div>
                        <p className="font-favorit text-[14px] font-[400] leading-[21px] text-theme-stroke text-center">
                            No Units Present in this project
                        </p>
                    </div>
                ) : (
                    <Collapse
                        bordered={false}
                        rootClassName="unit-collapse"
                        expandIcon={(panelProps) =>
                            expandIcon(
                                {
                                    isActive: panelProps.isActive,
                                } || {},
                            )
                        }
                        expandIconPosition="end"
                        collapsible="icon"
                        items={items}
                        activeKey={activeKeys}
                        onChange={(key) => setActiveKeys(key)}
                    />
                )}
            </div>
            <DeleteModel
                isOpen={isModelOpen}
                onClose={() => {
                    handleCancel();
                }}
                name={selectedUnit?._name}
                onConfirm={() => handleConfirmDelete()}
            />
        </>
    );
});

export default UnitCloset;
